import { getCurrentInstance } from 'vue'

export function trackGroupEvent(action: string, params: Record<string, unknown> = {}) {
  const internalInstance = getCurrentInstance()
  const gtag = internalInstance?.proxy?.$gtag
  if (gtag) {
    gtag.event(action, params)
  } else {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', action, params)
    }
  }
}
